import { SharedUtils } from "../utilities/shared-utils";
import { CitizenBasicInfo } from "./citizen-basic-info.dto";

export class UserBasicInfo {

    id: number | undefined;
    nickname: string | undefined;
    email: string | undefined;
    // protected token: string | undefined;
    statusId: number | undefined;
    roles: EnumUserRole[] | undefined;
    rolesNew: EnumUserRole[] | undefined;

    citizenInfo: CitizenBasicInfo | undefined;

    public getRolesKeyString(): string {
        let userRoles: string = "";
        if (SharedUtils.inputValueIsPresent(this.roles) && this.roles!.length > 0) {
            this.roles!.forEach( (role: EnumUserRole) => {
                if (userRoles === "") {
                    userRoles = role.toString() === "NONE" ? userRoles : userRoles.concat(role.toString());
                } else {
                    userRoles = role.toString() === "NONE" ? userRoles : userRoles.concat(", " + role.toString());
                }
            });
        }
        return userRoles;
    }

    public getRolesValueString(): string | undefined {
        let userRoles: string = "";
        if (SharedUtils.inputValueIsPresent(this.roles) && this.roles!.length > 0) {
            this.roles!.forEach( (role: EnumUserRole) => {
                if (userRoles === "") {
                    userRoles = (role.toString() === "NONE") ? userRoles : userRoles.concat( (SharedUtils.getEnumValue(EnumUserRole, role)?.toString() ?? "") );
                } else {
                    userRoles = role.toString() === "NONE" ? userRoles : userRoles.concat(", " + (SharedUtils.getEnumValue(EnumUserRole, role)?.toString() ?? "") );
                }
            });
        }
        return userRoles;
    }

    public getRolesNewKeyString(): string {
        let userRoles: string = "";
        if (SharedUtils.inputValueIsPresent(this.rolesNew) && this.rolesNew!.length > 0) {
            this.rolesNew!.forEach( (role: EnumUserRole) => {
                if (userRoles === "") {
                    userRoles = role.toString() === "NONE" ? userRoles : userRoles.concat(role.toString());
                } else {
                    userRoles = role.toString() === "NONE" ? userRoles : userRoles.concat(", " + role.toString());
                }
            });
        }
        return userRoles;
    }

    public getRolesNewValueString(): string | undefined {
        let userRoles: string = "";
        if (SharedUtils.inputValueIsPresent(this.rolesNew) && this.rolesNew!.length > 0) {
            this.rolesNew!.forEach( (role: EnumUserRole) => {
                if (userRoles === "") {
                    userRoles = (role.toString() === "NONE") ? userRoles : userRoles.concat( (SharedUtils.getEnumValue(EnumUserRole, role)?.toString() ?? "") );
                } else {
                    userRoles = role.toString() === "NONE" ? userRoles : userRoles.concat(", " + (SharedUtils.getEnumValue(EnumUserRole, role)?.toString() ?? "") );
                }
            });
        }
        return userRoles;
    }

    getStatusValueString(): string {
        return EnumUserStatus[this.statusId ?? 0] as string;
    }
}

export enum EnumUserRole {
    NONE="none",
    ANY="any",
    BUILDING_RESIDENT="condomino",
    CUSTOMER_CARE="assistenza I livello",
    DATA_ANALYST="elaborazione dati",
    LESSEE="locatario",
    LESSOR="locatore",
    REGISTERED_ACCOUNT="utente registrato",
    SYSTEM_ADMINISTRATOR="amministratore di sistema",
    USER_MANAGER="gestore utenze"
}

export enum EnumUserStatus {
    unknown = 0,
    approval = 1,
    active = 2,
    refused = 3,
    inactive = 4,
    suspended = 5,
    banned = 6,
    erased = 7
}

export enum EnumRoleFullIdentifier {
    'NONE.NONE.NONE' = 'NONE.NONE.NONE',
    'ANY.ANY.ANY' = 'ANY.ANY.ANY',
    'BUILDINGS_RESIDENT.NONE.NONE' = 'BUILDINGS_RESIDENT.NONE.NONE',
    'CUSTOMER_CARE.NONE.NONE' = 'CUSTOMER_CARE.NONE.NONE',
    'DATA_ANALYST.NONE.NONE' = 'DATA_ANALYST.NONE.NONE',
    'LESSEE.NONE.NONE' = 'LESSEE.NONE.NONE',
    'LESSOR.NONE.NONE' = 'LESSOR.NONE.NONE',
    'REGISTERED_ACCOUNT.NONE.NONE' = 'REGISTERED_ACCOUNT.NONE.NONE',
    'SYSTEM_ADMINISTRATOR.NONE.NONE' = 'SYSTEM_ADMINISTRATOR.NONE.NONE',
    'USER_MANAGER.NONE.NONE' = 'USER_MANAGER.NONE.NONE',
    'BUILDINGS_RESIDENT.ANY.ANY' = 'BUILDINGS_RESIDENT.ANY.ANY',
    'CUSTOMER_CARE.ANY.ANY' = 'CUSTOMER_CARE.ANY.ANY',
    'DATA_ANALYST.ANY.ANY' = 'DATA_ANALYST.ANY.ANY',
    'LESSEE.ANY.ANY' = 'LESSEE.ANY.ANY',
    'LESSOR.ANY.ANY' = 'LESSOR.ANY.ANY',
    'REGISTERED_ACCOUNT.ANY.ANY' = 'REGISTERED_ACCOUNT.ANY.ANY',
    'SYSTEM_ADMINISTRATOR.ANY.ANY' = 'SYSTEM_ADMINISTRATOR.ANY.ANY',
    'USER_MANAGER.ANY.ANY' = 'USER_MANAGER.ANY.ANY',
    'ANY.SURVEYOR_CUSTOMER.ADMINISTRATOR' = 'ANY.SURVEYOR_CUSTOMER.ADMINISTRATOR',
    'BUILDINGS_RESIDENT.SURVEYOR_CUSTOMER.ADMINISTRATOR' = 'BUILDINGS_RESIDENT.SURVEYOR_CUSTOMER.ADMINISTRATOR',
    'CUSTOMER_CARE.SURVEYOR_CUSTOMER.ADMINISTRATOR' = 'CUSTOMER_CARE.SURVEYOR_CUSTOMER.ADMINISTRATOR',
    'DATA_ANALYST.SURVEYOR_CUSTOMER.ADMINISTRATOR' = 'DATA_ANALYST.SURVEYOR_CUSTOMER.ADMINISTRATOR',
    'LESSEE.SURVEYOR_CUSTOMER.ADMINISTRATOR' = 'LESSEE.SURVEYOR_CUSTOMER.ADMINISTRATOR',
    'LESSOR.SURVEYOR_CUSTOMER.ADMINISTRATOR' = 'LESSOR.SURVEYOR_CUSTOMER.ADMINISTRATOR',
    'REGISTERED_ACCOUNT.SURVEYOR_CUSTOMER.ADMINISTRATOR' = 'REGISTERED_ACCOUNT.SURVEYOR_CUSTOMER.ADMINISTRATOR',
    'SYSTEM_ADMINISTRATOR.SURVEYOR_CUSTOMER.ADMINISTRATOR' = 'SYSTEM_ADMINISTRATOR.SURVEYOR_CUSTOMER.ADMINISTRATOR',
    'USER_MANAGER.SURVEYOR_CUSTOMER.ADMINISTRATOR' = 'USER_MANAGER.SURVEYOR_CUSTOMER.ADMINISTRATOR',
    'ANY.SURVEYOR_CUSTOMER.DOSSIER_MANAGER' = 'ANY.SURVEYOR_CUSTOMER.DOSSIER_MANAGER',
    'BUILDINGS_RESIDENT.SURVEYOR_CUSTOMER.DOSSIER_MANAGER' = 'BUILDINGS_RESIDENT.SURVEYOR_CUSTOMER.DOSSIER_MANAGER',
    'CUSTOMER_CARE.SURVEYOR_CUSTOMER.DOSSIER_MANAGER' = 'CUSTOMER_CARE.SURVEYOR_CUSTOMER.DOSSIER_MANAGER',
    'DATA_ANALYST.SURVEYOR_CUSTOMER.DOSSIER_MANAGER' = 'DATA_ANALYST.SURVEYOR_CUSTOMER.DOSSIER_MANAGER',
    'LESSEE.SURVEYOR_CUSTOMER.DOSSIER_MANAGER' = 'LESSEE.SURVEYOR_CUSTOMER.DOSSIER_MANAGER',
    'LESSOR.SURVEYOR_CUSTOMER.DOSSIER_MANAGER' = 'LESSOR.SURVEYOR_CUSTOMER.DOSSIER_MANAGER',
    'REGISTERED_ACCOUNT.SURVEYOR_CUSTOMER.DOSSIER_MANAGER' = 'REGISTERED_ACCOUNT.SURVEYOR_CUSTOMER.DOSSIER_MANAGER',
    'SYSTEM_ADMINISTRATOR.SURVEYOR_CUSTOMER.DOSSIER_MANAGER' = 'SYSTEM_ADMINISTRATOR.SURVEYOR_CUSTOMER.DOSSIER_MANAGER',
    'USER_MANAGER.SURVEYOR_CUSTOMER.DOSSIER_MANAGER' = 'USER_MANAGER.SURVEYOR_CUSTOMER.DOSSIER_MANAGER',
    'ANY.SURVEYOR_CUSTOMER.USER_MANAGER' = 'ANY.SURVEYOR_CUSTOMER.USER_MANAGER',
    'BUILDINGS_RESIDENT.SURVEYOR_CUSTOMER.USER_MANAGER' = 'BUILDINGS_RESIDENT.SURVEYOR_CUSTOMER.USER_MANAGER',
    'CUSTOMER_CARE.SURVEYOR_CUSTOMER.USER_MANAGER' = 'CUSTOMER_CARE.SURVEYOR_CUSTOMER.USER_MANAGER',
    'DATA_ANALYST.SURVEYOR_CUSTOMER.USER_MANAGER' = 'DATA_ANALYST.SURVEYOR_CUSTOMER.USER_MANAGER',
    'LESSEE.SURVEYOR_CUSTOMER.USER_MANAGER' = 'LESSEE.SURVEYOR_CUSTOMER.USER_MANAGER',
    'LESSOR.SURVEYOR_CUSTOMER.USER_MANAGER' = 'LESSOR.SURVEYOR_CUSTOMER.USER_MANAGER',
    'REGISTERED_ACCOUNT.SURVEYOR_CUSTOMER.USER_MANAGER' = 'REGISTERED_ACCOUNT.SURVEYOR_CUSTOMER.USER_MANAGER',
    'SYSTEM_ADMINISTRATOR.SURVEYOR_CUSTOMER.USER_MANAGER' = 'SYSTEM_ADMINISTRATOR.SURVEYOR_CUSTOMER.USER_MANAGER',
    'USER_MANAGER.SURVEYOR_CUSTOMER.USER_MANAGER' = 'USER_MANAGER.SURVEYOR_CUSTOMER.USER_MANAGER',
    'ANY.SURVEYOR_SUPPLIER.ADMINISTRATOR' = 'ANY.SURVEYOR_SUPPLIER.ADMINISTRATOR',
    'BUILDINGS_RESIDENT.SURVEYOR_SUPPLIER.ADMINISTRATOR' = 'BUILDINGS_RESIDENT.SURVEYOR_SUPPLIER.ADMINISTRATOR',
    'CUSTOMER_CARE.SURVEYOR_SUPPLIER.ADMINISTRATOR' = 'CUSTOMER_CARE.SURVEYOR_SUPPLIER.ADMINISTRATOR',
    'DATA_ANALYST.SURVEYOR_SUPPLIER.ADMINISTRATOR' = 'DATA_ANALYST.SURVEYOR_SUPPLIER.ADMINISTRATOR',
    'LESSEE.SURVEYOR_SUPPLIER.ADMINISTRATOR' = 'LESSEE.SURVEYOR_SUPPLIER.ADMINISTRATOR',
    'LESSOR.SURVEYOR_SUPPLIER.ADMINISTRATOR' = 'LESSOR.SURVEYOR_SUPPLIER.ADMINISTRATOR',
    'REGISTERED_ACCOUNT.SURVEYOR_SUPPLIER.ADMINISTRATOR' = 'REGISTERED_ACCOUNT.SURVEYOR_SUPPLIER.ADMINISTRATOR',
    'SYSTEM_ADMINISTRATOR.SURVEYOR_SUPPLIER.ADMINISTRATOR' = 'SYSTEM_ADMINISTRATOR.SURVEYOR_SUPPLIER.ADMINISTRATOR',
    'USER_MANAGER.SURVEYOR_SUPPLIER.ADMINISTRATOR' = 'USER_MANAGER.SURVEYOR_SUPPLIER.ADMINISTRATOR',
    'ANY.SURVEYOR_SUPPLIER.DOSSIER_MANAGER' = 'ANY.SURVEYOR_SUPPLIER.DOSSIER_MANAGER',
    'BUILDINGS_RESIDENT.SURVEYOR_SUPPLIER.DOSSIER_MANAGER' = 'BUILDINGS_RESIDENT.SURVEYOR_SUPPLIER.DOSSIER_MANAGER',
    'CUSTOMER_CARE.SURVEYOR_SUPPLIER.DOSSIER_MANAGER' = 'CUSTOMER_CARE.SURVEYOR_SUPPLIER.DOSSIER_MANAGER',
    'DATA_ANALYST.SURVEYOR_SUPPLIER.DOSSIER_MANAGER' = 'DATA_ANALYST.SURVEYOR_SUPPLIER.DOSSIER_MANAGER',
    'LESSEE.SURVEYOR_SUPPLIER.DOSSIER_MANAGER' = 'LESSEE.SURVEYOR_SUPPLIER.DOSSIER_MANAGER',
    'LESSOR.SURVEYOR_SUPPLIER.DOSSIER_MANAGER' = 'LESSOR.SURVEYOR_SUPPLIER.DOSSIER_MANAGER',
    'REGISTERED_ACCOUNT.SURVEYOR_SUPPLIER.DOSSIER_MANAGER' = 'REGISTERED_ACCOUNT.SURVEYOR_SUPPLIER.DOSSIER_MANAGER',
    'SYSTEM_ADMINISTRATOR.SURVEYOR_SUPPLIER.DOSSIER_MANAGER' = 'SYSTEM_ADMINISTRATOR.SURVEYOR_SUPPLIER.DOSSIER_MANAGER',
    'USER_MANAGER.SURVEYOR_SUPPLIER.DOSSIER_MANAGER' = 'USER_MANAGER.SURVEYOR_SUPPLIER.DOSSIER_MANAGER',
    'ANY.SURVEYOR_SUPPLIER.USER_MANAGER' = 'ANY.SURVEYOR_SUPPLIER.USER_MANAGER',
    'BUILDINGS_RESIDENT.SURVEYOR_SUPPLIER.USER_MANAGER' = 'BUILDINGS_RESIDENT.SURVEYOR_SUPPLIER.USER_MANAGER',
    'CUSTOMER_CARE.SURVEYOR_SUPPLIER.USER_MANAGER' = 'CUSTOMER_CARE.SURVEYOR_SUPPLIER.USER_MANAGER',
    'DATA_ANALYST.SURVEYOR_SUPPLIER.USER_MANAGER' = 'DATA_ANALYST.SURVEYOR_SUPPLIER.USER_MANAGER',
    'LESSEE.SURVEYOR_SUPPLIER.USER_MANAGER' = 'LESSEE.SURVEYOR_SUPPLIER.USER_MANAGER',
    'LESSOR.SURVEYOR_SUPPLIER.USER_MANAGER' = 'LESSOR.SURVEYOR_SUPPLIER.USER_MANAGER',
    'REGISTERED_ACCOUNT.SURVEYOR_SUPPLIER.USER_MANAGER' = 'REGISTERED_ACCOUNT.SURVEYOR_SUPPLIER.USER_MANAGER',
    'SYSTEM_ADMINISTRATOR.SURVEYOR_SUPPLIER.USER_MANAGER' = 'SYSTEM_ADMINISTRATOR.SURVEYOR_SUPPLIER.USER_MANAGER',
    'USER_MANAGER.SURVEYOR_SUPPLIER.USER_MANAGER' = 'USER_MANAGER.SURVEYOR_SUPPLIER.USER_MANAGER',
    'ANY.SURVEYOR_CUSTOMER.ANY' = 'ANY.SURVEYOR_CUSTOMER.ANY',
    'ANY.SURVEYOR_SUPPLIER.ANY' = 'ANY.SURVEYOR_SUPPLIER.ANY',
    'ANY.ANY.ADMINISTRATOR' = 'ANY.ANY.ADMINISTRATOR',
    'ANY.ANY.DOSSIER_MANAGER' = 'ANY.ANY.DOSSIER_MANAGER',
    'ANY.ANY.USER_MANAGER' = 'ANY.ANY.USER_MANAGER',
    'ANY.ANY.DOSSIER_DISPATCHER' = 'ANY.ANY.DOSSIER_DISPATCHER',
}